import * as React from 'react';

export default () => (
  <div className="alert alert-info text-center">
    No se encontraron registros
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Shared/NoRecords.tsx